import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import {connect} from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { firstNameFirst } from "../../helpers/formatting";
import { queryParams } from "../../helpers/formatting";

const DATE_FORMAT = Tools.getDateFormats();

class ServiceVerifyNSchedule extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.editAppt = this.editAppt.bind(this);
        this.location = this.editReasonForVisit.bind(this)
        this.formatTime = this.formatTime.bind(this);
        this.onGoNext = this.onGoNext.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ServiceVerifyNSchedule.ComponentDidMount", new Date(), Tools.getURLPath());
       
    }   
    componentDidUpdate(prevProps){
        const {location, byPassProxyAndInfo } = this.props;
         
        const params = location.search ? queryString.parse(location.search) : {};
        const { s } = params;
        if(byPassProxyAndInfo && prevProps.byPassProxyAndInfo===byPassProxyAndInfo && prevProps!==this.props && typeof s !== 'undefined' && s==3)
        {
            this.props.updateBypassProxyAndInfo(false); 
        }
    }
    getDayOfWeek(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        var weekday = new Array(7);
        weekday[0] = "SUN";
        weekday[1] = "MON";
        weekday[2] = "TUE";
        weekday[3] = "WED";
        weekday[4] = "THU";
        weekday[5] = "FRI";
        weekday[6] = "SAT";
        if (Object.prototype.toString.call(dt) === '[object Date]') {
            var strDay = weekday[dt.getDay()];
            return strDay;
        }
        return "Invalid Date";
    }

    date2str(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        const dayName = dt.getDate();
        let monthName = dt.getMonth() + 1;
        if (monthName < 10)
            monthName = "0" + monthName;
        return `${Tools.getMonthName(monthName.toString())} ${dayName}`;
    }

    formatTime(s) {
        let parts = s ? s.split(":") : [];
        let ret = s;

        if (parts.length >= 2) {
            let h = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let s = parseInt(parts[2]);

            let ispm = h >= 12;
            h = h > 12 ? h - 12 : h;

            ret = `${h.toString()}:${m.toString().padStart(2, '0')} ${ispm ? "PM" : "AM"}`;
        }

        return ret;
    }

    editAppt(e) {
        if (e) { e.preventDefault(); }
        this.props.updateBypassProxyAndInfo(true);
        this.props.goBack(0);
    }

    editReasonForVisit(e) {
        if (e) { e.preventDefault(); }
        this.props.goBack(this.props.stepManager.state.currentStep - 1);
    }

    onGoNext() {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    }

    render() {
        const { visit, primaryUser, scheduleAppointmentForProxy, currentUser, visitTypelabel} = this.props;

        let patientName = (visit.patient && visit.patient.name) ? visit.patient.name : (primaryUser && primaryUser.displayName ? primaryUser.displayName : "");
        patientName = scheduleAppointmentForProxy ? currentUser ? primaryUser.eid === currentUser.eid ? firstNameFirst(primaryUser.displayName) : firstNameFirst(currentUser.displayName) : patientName : patientName;
        const address = visit.department.address;
        const { label, label2 } = this.props.departments[0] || {};       
        const location = address && (address.street1 || address.city) ? (address.street1 ? address.street1 + ', ' : '') + address.city + ', ' + address.state + ' ' + address.zip : "-";
        const appendVisit = visit.visitType.description.toLowerCase().indexOf("visit") >= 0 ? "" : " Visit";
        const appt = {
            visitType: visit.visitType.description + appendVisit,
            TimeString: this.formatTime(visit.time),
            DayString: this.getDayOfWeek(visit.date),
            DateString: this.date2str(visit.date)
        };

        const findcareSearchParms = "?" + queryParams({
            keyword: "mammography",
            tab: 2,
            bypassProxyAndInfo: false
        });

        return (
            <div className="row review-submission-container" style={this.props.style}>
                <div className="col-12">
                    
                    <h1 className="step-heading">You're almost done! Do these details look correct?</h1>
                </div>
                <div className="col-12 review-details-container verify-schedule-edit-container">
                    <div className="row justify-content-md-center row-verify-schedule">
                        <div className="col-12 col-md-8 col-md-offset-3">
                            <h2 className="h5  text-center">Reason for Visit</h2>
                            <div className="text-center">{visitTypelabel.replace('d', 'D')}</div>
                        </div>
                    </div>
                    <div className="row justify-content-md-center row-verify-schedule">
                        <div className="col-12 col-lg-6 col-md-10">
                            <h2 className="h5">Patient</h2>
                            <div className="review-details">
                                {patientName}
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div>
                    <div className="row justify-content-md-center row-verify-schedule">
                        <div className="col-12 col-lg-6 col-md-10">
                            <h2 className="h5">Day & Time</h2>
                            <div className="review-details">
                                <span>{appt.DayString}, {appt.DateString}, {appt.TimeString}</span>
                            </div>
                            <div className="review-edit-btn">
                                <button type="button" className="btn-verify-schedule-edit" onClick={(e) => this.editAppt(e)}>Edit</button>
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div>
                    <div className="row justify-content-md-center row-verify-schedule">
                        <div className="col-12 col-lg-6 col-md-10">
                            <h2 className="h5">Location</h2>
                            <div className="review-details">
                                <span>{label || ''}</span>
                            </div>
                            <div className="review-details">
                                <span>{location}</span>
                            </div>
                            <div className="change-location-container review-edit-btn">
                                <Link to={{ pathname: "/findcare", search:findcareSearchParms}}>
                                    <button type="button" className="btn-verify-schedule-edit" onClick={() => this.props.updateBypassProxyAndInfo(false)}>Edit</button>
                                </Link>
                            </div>

                            <div className="hr-divider" />
                        </div>
                    </div>
                    <div className="mammogram-message-container justify-content-md-center row-verify-schedule row">
                        <div className="col-12 col-lg-6 col-md-10">
                            <div className="mammogram-message-image">
                                <span className="icon-info-filled"></span>
                            </div>
                            <div className="mammogram-message-text">Before your appointment, please verify with your insurance carrier the nature and extent of the coverage, services, facilities, and providers that will be considered in-network.</div>
                        </div>
                    </div>
                </div>
                

                <div className="row">
                    <div className="col-12">
                        <div className="footer-buttons">
                            <button type="button" className="btn btn-primary" onClick={() => { this.onGoNext() }}>VERIFY & SCHEDULE</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        byPassProxyAndInfo: state.openScheduling.byPassProxyAndInfo, 
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateBypassProxyAndInfo: payload => dispatch({ type: types.UPDATE_BYPASS_PROXY_AND_INFO, payload })
    };
};

export default withRouter(connect(mapStateToProps,  mapDispatchToProps)(ServiceVerifyNSchedule));
